<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>文件管理</el-breadcrumb-item>
    <el-breadcrumb-item>文件上传</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>
    
    <el-row>
  <el-col :span="4"><div class="grid-content bg-purple-dark"><el-input v-model="querys.particulars"  @keyup.enter.native="getCloudFiles" placeholder="文件介绍"></el-input></div></el-col>
  <el-col :span="4"><div class="grid-content bg-purple-dark"><el-input v-model="querys.old_name"  @keyup.enter.native="getCloudFiles" placeholder="文件名称"></el-input></div></el-col>
  <el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary" @click="getCloudFiles">查询</el-button></div></el-col>
</el-row>
<el-table
    ref="multipleTable"
    :data="cloudFileList"
    border
    height="500"
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
    >
    <el-table-column
      label="上传人"
      width="120"
      :show-overflow-tooltip="true"
      prop="name">
    </el-table-column>
    <el-table-column
      label="上传人用户名"
      width="120"
      :show-overflow-tooltip="true"
      prop="username">
    </el-table-column>
    <el-table-column
      label="上传ID"
      width="120"
      :show-overflow-tooltip="true"
      prop="cloud_id">
      
    </el-table-column>
    <el-table-column
      label="文件介绍"
      width="120"
      :show-overflow-tooltip="true"
      prop="particulars">
      
    </el-table-column>
    <el-table-column
      label="文件大小（M）"
      width="130"
      :formatter="formatter_file_size"
      :show-overflow-tooltip="true"
      prop="file_size">
      
    </el-table-column>
    
    <el-table-column
      prop="sub_time"
      label="上传时间"
      :show-overflow-tooltip="true"
      width="170">
    </el-table-column>
    <el-table-column
      prop="old_name"
      label="文件名"
      :show-overflow-tooltip="true"
      width="170">
    </el-table-column>
    <el-table-column
      prop="is_public"
      label="文件权限"
      :formatter="is_publicFormatter"
      :show-overflow-tooltip="true"
      width="170">
    </el-table-column>
 <el-table-column
      label="操作"
      width="240">

        <template slot-scope="scope" >
   <el-button type="primary"   @click="downFile(scope.row)">下载</el-button>
   <!-- <el-button type="danger"   @click="delFile(scope.row)">删除</el-button> -->
      </template>
    </el-table-column>

  </el-table>

  <div class="block">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>

  </el-card>

  <el-dialog
  title="文件上传"
  :visible.sync="dialogVisible"
  width="50%"
 >
  <!-- 添加工作 -->
  <el-form :model="formData"  ref="ruleForms" label-width="100px" class="demo-ruleForm">

  <el-form-item label="文件介绍">
    <el-input type="textarea" v-model="formData.particulars"></el-input>
  </el-form-item>

  <el-form-item label="是否公共" prop="is_public">
   <el-radio-group v-model="formData.is_public">
      <el-radio border :label="false">私有</el-radio>
      <el-radio border :label="true">公用</el-radio>
    </el-radio-group>
    </el-form-item>

    <el-form-item label="上传附加文件" span='8'>
            <el-upload
                class="upload-demo"
                drag
                action="https://jsonplaceholder.typicode.com/posts/"
                :auto-upload="false"
                :on-change="fileChange3"
                ref="uploadss"
                :limit="5"
                :on-remove="fileRemove3"
                width="40%"
              
                >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
                 
          </el-form-item>



  <el-form-item>
    <el-button type="primary" @click="subfile()">提交</el-button>
    <!-- <el-button @click="resetForm('ruleForms')">重置</el-button> -->
  </el-form-item>
</el-form>
</el-dialog>
</div>
</template>

<script>
export default {
  created(){
    this.getCloudFiles()
  },
data(){
    return{
        formData:{
            particulars:'',
            fileList7:[],
          fileList8:[],
          fileList:[],
            is_public:false,
            file:null
        },
        querys:{
          
          pageNum:null,
          pageSize:null,
        },
        total:null,
        currentPage4: 1,
        dialogVisible:false,
        cloudFileList:[],
    }
},methods:{
  getCloudFiles(){
    
    this.axios.post("/cloudFile/getCloudFilesByIsPublicMap"+this.$formateDate.tansParams(this.querys))
             .then(resp=>{
              console.log(resp)
              if(resp.data.status==1){
                console.log(resp.data.result)
                this.total=resp.data.result.total
                this.cloudFileList=resp.data.result.rows
              }
             })
  },
    subfile(){
      const subData= this.getFormData()
      let config = { headers: { "Content-Type": "multipart/form-data" } };    
        this.axios.post("/cloudFile/subFile", subData,config)
        .then((resp) => {
          if (resp.data.status == 1) {
                 this.dialogVisible=false
    
            this.$message.success("添加成功");
            this.getCloudFiles()
          } else {
            this.$message.error("发生过错误"+resp.data.message);
            this.loading=false
          }
        })
        .catch((err) => {
          this.$message.error("出错");
          this.loading=false
        });

    },fileChange3(file, fileList){
        this.fileList7=fileList
      },fileRemove3(file, fileList){
        this.fileList7=fileList
      },
      getFormData(){
        const fd = new FormData();
        fd.append("particulars",this.formData.particulars)
        fd.append("is_public",this.formData.is_public)
        this.fileList7.forEach((file) => {
          fd.append("fileList", file.raw);
       });
       return fd
      },downFile(data){
        console.log(data)
      const formData = new FormData()
      formData.append('filePath', data.cloud_file_url)
      this.axios({
            url: "/file/downFile",   //后端地址
            method: "post",
            data:formData, //请求参数
            headers: {  
            'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
            },
            // contenType:'application/json',
            responseType: "blob"
          })
            .then(res => {
              console.log(res.data)
          const blob = new Blob([res.data], { type: 'xlsx' });
          const fileName = data.old_name; 
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink); 
            this.selectData=false
      
            })
      },is_publicFormatter(row, column){
       if(row.is_public){
        return "公用文件"
       }else{
        return "私有文件"
       }
      },formatter_file_size(row, column){
       
       return (row.file_size/1024/1024).toFixed(2)
      },
      
      
      delFile(data){
        const fd = new FormData();
        fd.append("cloud_file_id",data.cloud_file_id)
        fd.append("filePath",data.cloud_file_url)
        this.axios.post("/cloudFile/delCloudFile",fd)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.getCloudFiles()
            this.$message.success("删除成功");
          } else {
            this.$message.error("发生过错误"+resp.data.message);

          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
      },      handleSizeChange(val) {
        if(val!=null||val!=''){
          this.querys.pageSize=val
        }
        console.log(`每页 ${val} 条`);
        this.getCloudFiles()
      },
      handleCurrentChange(val) {
        if(val!=null||val!=''){
          this.querys.pageNum=val
        }
        console.log(`当前页: ${val}`);
        this.getCloudFiles()
      }
}

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/teacher/PublicCloudFile.vue